import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  r,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/stepper/step-panel.ts
var FadvStepPanel = class extends s {
  constructor() {
    super(...arguments);
    this.active = false;
  }
  render() {
    return $`<div class=${o({
      "step-panel": true,
      "step-panel--active": this.active
    })} ><slot></slot></div>`;
  }
};
FadvStepPanel.styles = r` .step-panel { display: none; } .step-panel.step-panel--active { display: block; } `;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvStepPanel.prototype, "active", 2);
__decorateClass([
  e()
], FadvStepPanel.prototype, "name", 2);
FadvStepPanel = __decorateClass([
  n("fadv-step-panel")
], FadvStepPanel);

export {
  FadvStepPanel
};
